import { render, staticRenderFns } from "./ShokurekishoSkillsCard.vue?vue&type=template&id=96591530"
import script from "./ShokurekishoSkillsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoSkillsCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports